import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onUnmounted } from 'vue';

import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

/** ... */
export interface RouletteItem {
  id: string;
  title: string;
  image: string | IconDefinition;
}

export interface Props {
  items: RouletteItem[];
  direction?: 'up' | 'down';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureRoulette',
  props: {
    items: null,
    direction: { default: 'down' }
  },
  setup(__props: any) {

const props = __props as { items: RouletteItem[], direction: 'up' | 'down' };



const offset = ref(0);
const hasMouseCursor = ref(false);
const pausedAt = ref<number | null>(null);
const intervalId = ref<number | null>(null);

/** ... */
const computedItems = computed(() => {
  const items: RouletteItem[] = [];

  const [first, second, ...others] = props.items;

  if (!first) return items;

  if (!second) {
    items.push(first, first, first);
  } else if (!others.length) {
    items.push(first, second, first);
  } else {
    items.push(first, second, ...others);
  }

  return items.map((item, index) => ({
    ...item,
    id: `${item.id}-${index}`,
  }));
});

/** ... */
const len = computed(() => computedItems.value.length);

/** ... */
const displayedItems = computed(() => {
  if (!len.value) return [];

  // ...
  const center = computedItems.value[offset.value];

  let it = offset.value - 1;
  it = it < 0 ? len.value - 1 : it;
  // ...
  const top = computedItems.value[it];

  let ib = offset.value + 1;
  ib = ib > len.value - 1 ? 0 : ib;
  // ...
  const bottom = computedItems.value[ib];

  if (!top || !bottom || !center) {
    throw new Error('[...]');
  }

  return [top, center, bottom];
});

onMounted(() => {
  startCycle();
});

onUnmounted(() => {
  stopCycle();
});

/**
 * Cycle roulette up.
 */
function cycleUp() {
  offset.value = offset.value >= len.value - 1 ? 0 : offset.value + 1;
}

/**
 * Cycle roulette down.
 */
function cycleDown() {
  offset.value = offset.value <= 0 ? len.value - 1 : offset.value - 1;
}

function runCycle() {
  if (hasMouseCursor.value) return;

  if (pausedAt.value) {
    const elapsedTime = Date.now() - pausedAt.value;

    if (elapsedTime < 10_000) return;

    pausedAt.value = null;
  }

  if (props.direction === 'up') {
    cycleUp();
  } else {
    cycleDown();
  }
}

/**
 * Start roulette cycle animation.
 */
function startCycle() {
  if (intervalId.value) return;

  intervalId.value = window.setInterval(runCycle, 5_000);
}

/**
 * Stop roulette cycle animation.
 */
function stopCycle() {
  if (!intervalId.value) return;

  window.clearInterval(intervalId.value);
}

/**
 * Pause roulette cycle animation.
 */
function pauseCycle() {
  pausedAt.value = Date.now();
}

/**
 * Set the current focus by an item index number.
 */
function setToFocus(index: number) {
  const direction = index === 0 ? 'up' : index === 2 ? 'down' : null;

  if (!direction) return;

  pauseCycle();

  if (direction === 'down') {
    cycleUp();
  } else {
    cycleDown();
  }
}

return { __sfc: true,props, offset, hasMouseCursor, pausedAt, intervalId, computedItems, len, displayedItems, cycleUp, cycleDown, runCycle, startCycle, stopCycle, pauseCycle, setToFocus }
}

})